const getUserID = () => {
    const user = JSON.parse(localStorage.getItem("user_paboi"));
    const id = user.data.id;
    return {
      id
    };
  };
  
  export default getUserID;
  